var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"text-sm d-none d-sm-block"},[_vm._v(" Copyright © Directorate of Town Planning and Survey Sharjah DTPS, "+_vm._s(_vm.currentYear)+", All Rights Reserved. ")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }